'use client'

import { cn } from '@mntn-dev/ui-utilities'
import {
  SectionHeader,
  type SectionHeaderProps,
} from '../../../headers/index.ts'
import { ModalHeaderAccent } from './modal-header-accent.tsx'
import { ModalHeaderTitle } from './modal-header-title.tsx'

export type ModalHeaderProps = SectionHeaderProps

const ModalHeader = ({ className, ...props }: ModalHeaderProps) => {
  return (
    <SectionHeader className={cn('mb-4 flex-initial', className)} {...props} />
  )
}

export const ModalHeaderNamespace = Object.assign(ModalHeader, {
  Accent: ModalHeaderAccent,
  Main: SectionHeader.Main,
  Subtitle: SectionHeader.Subtitle,
  Title: ModalHeaderTitle,
})

export { ModalHeaderNamespace as ModalHeader }
